import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const iscrizioniCorsiSlice = createSlice({
  name: 'iscrizioniCorsi',
  initialState,
  reducers: {
    setIscrizioneCorsi(state, action) {
      state.iscrizioneCorsi = action.payload
    },
    setIscrizioneCorsiField(state, action) {
      if (!state.iscrizioneCorsi) state.iscrizioneCorsi = {}
      state.iscrizioneCorsi[action.payload.field] = action.payload.value
    },
  },
})

export const { setIscrizioneCorsi, setIscrizioneCorsiField } =
  iscrizioniCorsiSlice.actions

export default iscrizioniCorsiSlice.reducer
